import React from 'react';
import UiContent from '../../../../Components/Common/UiContent';
import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import ReportingStatusList from './ReportingStatusList';

const ReportingStatuses = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Derechos de Agua', icon: 'icon-droplets' },
		{ to: '#', label: 'Configuración', icon: 'icon-settings' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Condición de Reportabilidad' links={breadcrumbLinks} icon={'icon-activity'} />
					<ReportingStatusList/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default ReportingStatuses;
